import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInfoCard from "../components/PersonalizationInfoCard";
import PersonalizationTextarea from "../components/PersonalizationTextarea";
import PersonalizationDivider from "../components/PersonalizationDivider";
import React, {useEffect, useState} from "react";
import PersonalizationCardTabPicker from "../components/PersonalizationCardTabPicker";
import PersonalizationButton from "../components/PersonalizationButton";
import {useTranslation} from "react-i18next";
import {restoreHealthMetric, restoreMetric, updateSurveyPersonalization} from "../../../../../../core/axios/services";
import {addUser} from "../../../../../../redux/actions/user";
import {useDispatch} from "react-redux";

export default function WellnessMetric({
                                                        user,
                                                        showGlobalSnackbar,
                                                        defaultWellnessMetrics,
                                                        wellnessMetricOrder,

                                                        languages,
                                                        activeLanguage,
                                                        setActiveLanguage,

                                                        allWellnessSettingsFormData,
                                                        setAllWellnessSettingsFormData,


                                                       getWellnessError,
                                                       wellnessFormData,
                                                       setWellnessFormData
}) {


    const {i18n} = useTranslation();
    const dispatch = useDispatch();
    const isWellnessScaleGreenToRed =
        wellnessFormData?.healthMetricScaleDesign === "green_to_red";
    const lowScaleIcon = isWellnessScaleGreenToRed
        ? "/assets/ic_like.svg"
        : "/assets/ic_dislike.svg";
    const highScaleIcon = isWellnessScaleGreenToRed
        ? "/assets/ic_dislike.svg"
        : "/assets/ic_like.svg";

    const [defaultBodyMetric, setDefaultBodyMetric] = useState();

    useEffect(() => {
        setDefaultBodyMetric(
            defaultWellnessMetrics?.find(item => item.languageId === activeLanguage?.id)
        );
    },[activeLanguage]);


    const updateBodyMetric = (property, value) => {
        const targetLanguageId =
            activeLanguage?.id ??
            wellnessFormData?.languageId ??
            wellnessFormData?.language?.id;
        if (!targetLanguageId) return;

        // Update all survey settings that match the current language
        const updatedSurveySettings = allWellnessSettingsFormData.map((survey) => {
            const surveyLanguageId = survey?.languageId ?? survey?.language?.id;
            if (surveyLanguageId === targetLanguageId) {
                return {
                    ...survey,
                    [property]: value,
                };
            }
            return survey;
        });
        setAllWellnessSettingsFormData(updatedSurveySettings);

        // setWellnessFormData({...wellnessFormData, [property]:value});
    };


    const [showRestorePopup, setShowRestorePopup] = useState(false);
    const [isReverting, setIsReverting] = useState(false);


    async function handleRestoreMetric() {
        setIsReverting(true);
        try {
            let response = await restoreMetric(wellnessMetricOrder,user);
            if (response?.status === 200) {
                showGlobalSnackbar(i18n.t("saveAndSyncMessage"));
                dispatch(addUser(response?.data?.data));

                setIsReverting(false);
                setShowRestorePopup(false);
                showGlobalSnackbar(i18n.t("saveAndSyncMessage"));
                console.log('NEW USER: ',response?.data?.data)
            }
        } catch (error) {
            console.log('error', error);
        }
        setIsReverting(false);
    }

    function getWellnessErrorMessage(property){
        return getWellnessError('surveySettings',`bodyMetrics.${wellnessMetricOrder - 1}.${property}`);
    }

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap: '20px'
    }}>
        <PersonalizationCardTabPicker
            tabs={languages}
            activeTab={activeLanguage}
            setActiveTab={setActiveLanguage}
        />

        <PersonalizationInfoCard
            text={'Editing any health metric will archive the current data and create a new set of statistics. You can make changes in any language, but the statistics will always be reset.'}
        />

        <PersonalizationCardImage src={`/assets/survey_personalization_screens/wellness/wellness_metric_${wellnessMetricOrder}.png`} alt={'Welcome Screen'}/>

        <PersonalizationInput
            title={'Title'}
            value={wellnessFormData?.[`healthMetric${wellnessMetricOrder}Title`]?.toUpperCase()}
            setValue={(value) => updateBodyMetric(`healthMetric${wellnessMetricOrder}Title`, value?.toUpperCase())}
            errorMessage={getWellnessErrorMessage(`healthMetric${wellnessMetricOrder}Title`)}
        />

        <PersonalizationTextarea
            title={'Question/Statement'}
            value={wellnessFormData?.[`healthMetric${wellnessMetricOrder}Question`]}
                setValue={(value) => updateBodyMetric(`healthMetric${wellnessMetricOrder}Question`, value)}
            errorMessage={getWellnessErrorMessage(`healthMetric${wellnessMetricOrder}Question`)}
        />

        <div style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: '20px',
        }}>
            <PersonalizationInput
                title={
                    <span style={{display: "inline-flex", alignItems: "center", gap: "4px"}}>
                        <img src={lowScaleIcon} alt={"Low Scale"} style={{width: "12px", height: "12px"}}/>
                        <span>Low Scale</span>
                    </span>
                }
                value={wellnessFormData?.[`healthMetric${wellnessMetricOrder}LowScale`]}
                setValue={(value) => updateBodyMetric(`healthMetric${wellnessMetricOrder}LowScale`, value)}
                errorMessage={getWellnessErrorMessage(`healthMetric${wellnessMetricOrder}LowScale`)}
            />
            <PersonalizationInput
                title={
                    <span style={{display: "inline-flex", alignItems: "center", gap: "4px"}}>
                        <img src={highScaleIcon} alt={"High Scale"} style={{width: "12px", height: "12px"}}/>
                        <span>High Scale</span>
                    </span>
                }
                value={wellnessFormData?.[`healthMetric${wellnessMetricOrder}HighScale`]}
                setValue={(value) => updateBodyMetric(`healthMetric${wellnessMetricOrder}HighScale`, value)}
                errorMessage={getWellnessErrorMessage(`healthMetric${wellnessMetricOrder}HighScale`)}
            />
        </div>

        {
            !wellnessFormData?.[`isHealthMetric${wellnessMetricOrder}Default`] &&
            <PersonalizationButton
                text={'Restore statement & statistics'}
                mode={"small"}
                onClick={() => setShowRestorePopup(true)}
            />
        }

        {showRestorePopup && (
            <div className="ScreenOverlay">
                <div className="ScreenContent">
            <h2 style={{marginBottom: "40px"}}>
                {i18n.t("restoreMainTitle")}
            </h2>
                    <PersonalizationInfoCard
                        text={i18n.t("restoreDesc")}
                        backgroundColor={'white'}
                        boxShadow='0px 2px 4px rgba(97,132,157,0.2)'
                    />

                    <div style={{
                        width: '100%',
                        textAlign: "left",
                        margin: '20px 0',
                    }}>
                        <label style={{color: '#494949'}}>Title</label>
                        <p style={{
                            paddingBottom: '20px',
                            borderBottom: '1px solid lightgray',
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>{defaultBodyMetric?.[`healthMetric${wellnessMetricOrder}Title`]}</p>

                        <label style={{color: '#494949'}}>Question/Statement</label>
                        <p style={{
                            paddingBottom: '20px',
                            borderBottom: '1px solid lightgray',
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>{defaultBodyMetric?.[`healthMetric${wellnessMetricOrder}Question`]}</p>

                        <label style={{color: '#494949'}}>Low scale</label>
                        <p style={{
                            paddingBottom: '20px',
                            borderBottom: '1px solid lightgray',
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>{defaultBodyMetric?.[`healthMetric${wellnessMetricOrder}LowScale`]}</p>

                        <label style={{color: '#494949'}}>High scale</label>
                        <p style={{
                            paddingBottom: '20px',
                            borderBottom: '1px solid lightgray',
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>{defaultBodyMetric?.[`healthMetric${wellnessMetricOrder}HighScale`]}</p>


                        <label style={{color: '#494949'}}>PDF title</label>
                        <p style={{
                            paddingBottom: '20px',
                            textAlign: 'left',
                            fontWeight: 'bold'
                        }}>{defaultBodyMetric?.[`healthMetric${wellnessMetricOrder}PdfTitle`]}</p>
                    </div>


                    <h4 style={{marginBottom: '30px'}}>{i18n.t("restoreMessage")}</h4>


                    <button
                        style={{
                            border: 'none',
                            outline: 'none',
                            color: 'white',
                            minWidth: '300px',
                            padding: '7px 20px',
                            borderRadius: "23px",
                            boxShadow: "0px 2px 4px rgba(217, 217, 217, 1)",
                            backgroundColor: "rgba(97, 132, 157, 1)"
                        }}
                        onClick={() => handleRestoreMetric()}
                        disabled={isReverting}
                    >
                        {isReverting ? "Saving..." : "Yes, apply"}
                    </button>


                    <div
                        style={{
                            cursor: 'pointer',
                            margin: '10px',
                            textDecoration: 'underline',
                        }}
                        onClick={() => setShowRestorePopup(false)}
                    >
                        Cancel
                    </div>
                </div>
            </div>
        )}

        <PersonalizationDivider/>

        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_health_pdf.png'} alt={'Welcome Screen'}/>

        <PersonalizationInput
            title={'Display on PDF as'}
            value={wellnessFormData?.[`healthMetric${wellnessMetricOrder}PdfTitle`]}
            setValue={(value) => updateBodyMetric(`healthMetric${wellnessMetricOrder}PdfTitle`, value)}
            errorMessage={getWellnessErrorMessage(`healthMetric${wellnessMetricOrder}PdfTitle`)}
        />
    </div>
}
